import config from 'constants/config'
import { ChertoExperiments } from 'constants/experiments'
import { getExperimentEnabledDecision, isAllowedToTriggerExperiment } from 'lib/optimizely/optimizelyUtils'

/**
 * State-based read of whether the current user is in the treatment variant of the
 * side-by-side insurance UI experiment (a Cherto experiment).
 *
 * The checkout section selectors decide which insurance section renders and cannot call the
 * `useExperiment` hook, so the decision is derived from `state.cherto`. It mirrors the hook's
 * Cherto branch (UTM/GHA exclusion, `CHERTO_<key>` local override, off/control normalisation)
 * so the section choice always agrees with the hook's `isAnyVariant`. Activation still happens
 * through `useExperiment` in the rendered insurance component.
 */
export function selectNewInsuranceUiIsVariant(state: App.State): boolean {
  const experimentId = ChertoExperiments.croNewInsuranceUi.id

  if (!isAllowedToTriggerExperiment(true, state.utm.content, experimentId)) {
    return false
  }

  const override = config[`CHERTO_${experimentId}`]
  const variationKey = override ?? state.cherto?.chertoExperiments?.[experimentId]?.variationKey

  return getExperimentEnabledDecision(variationKey)
}
